import { registerQuery } from 'data-fetching-client';
import * as t from 'ts-schema';
import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GENERATE_REVIEW_TITLE = registerQuery({
  fieldName: 'title',
  fetcher: queries => ecosystemAppClient.post(`reviews/generate-title`, {
    data: Object.assign({}, queries, {
      type: queries.reviewType
    })
  }).then(response => t.assert(t.object({
    title: t.string
  }), response))
});